import React from "react";
import { registerEmails, registerPhoneNumbers } from "@wrstudios/utils";
import Link from "../link";
import Avatar from "../user-avatar";
import { Container, Header, Showing, Description, Footer, Agent, AgentDetails, AgentAvatar, AgentName, Divider, Disclaimer } from "./styled/listing-showings";
function ListingShowings(_a) {
    var showings = _a.showings, privateRemarks = _a.privateRemarks, agentUrl = _a.agentUrl, agentName = _a.agentName, agentInitials = _a.agentInitials, agentInitialsColor = _a.agentInitialsColor, agentEmail = _a.agentEmail, agentPhone = _a.agentPhone, officeName = _a.officeName;
    var agent = (React.createElement(AgentAvatar, null,
        React.createElement(Avatar, { size: "md", initials: agentInitials || "", initialsColor: agentInitialsColor })));
    var modifiedPrivateRemarks = registerEmails(registerPhoneNumbers(privateRemarks));
    var modifiedShowings = registerEmails(registerPhoneNumbers(showings));
    var hasPrivateRemarks = !!privateRemarks;
    var hasShowings = !!showings;
    return (React.createElement(Container, null,
        React.createElement(Header, null, "Showings"),
        React.createElement(Showing, null,
            hasShowings && (React.createElement(Description, { dangerouslySetInnerHTML: { __html: modifiedShowings } })),
            hasPrivateRemarks && (React.createElement(Description, { dangerouslySetInnerHTML: { __html: modifiedPrivateRemarks } })),
            React.createElement(Footer, null,
                React.createElement(Agent, null,
                    !agentUrl ? agent : React.createElement(Link, { to: agentUrl }, agent),
                    React.createElement(AgentDetails, null,
                        React.createElement(AgentName, null, agentName),
                        officeName && React.createElement("div", null, officeName),
                        agentPhone && React.createElement("a", { href: "tel:" + agentPhone }, agentPhone),
                        agentPhone && agentEmail && React.createElement(Divider, null, " \u2022 "),
                        agentEmail && React.createElement("a", { href: "mailto:" + agentEmail }, agentEmail))),
                React.createElement(Disclaimer, null, "Agents only")))));
}
export default ListingShowings;
